import { PositionDto, PrivateQuoteDto, PrivateQuoteSnapDto } from 'src/dtos';
import { Position } from 'src/models';

const enrichNonTradablePosition = (model: Position, privateQuote: PrivateQuoteDto): Position => {
  let result: Position = {
    ...model,
    isTradable: false,
    value: privateQuote.currentPrice,
    totalValue: model.quantity * privateQuote.currentPrice,
  };

  if (result.purchasePrice === 0) {
    result.purchasePrice = privateQuote.purchasePrice;
  }

  return result;
};

const addNonTradablePositionSnapIfFound = (model: Position, snap: PrivateQuoteSnapDto[]): Position => {
  const privateQuoteSnap = snap?.find(aPrivateQuoteSnap => aPrivateQuoteSnap.symbol === model.symbol);

  if (!privateQuoteSnap) {
    return model;
  }
  let result = { ...model };

  if (!isNaN(privateQuoteSnap.lastPrice) && privateQuoteSnap.lastPrice !== 0) {
    result.value = privateQuoteSnap.lastPrice;
    result.totalValue = result.quantity * privateQuoteSnap.lastPrice;
  }

  return result;
};

const makeNonTradablePositionIfFound = (
  model: Position,
  privateQuotes: PrivateQuoteDto[],
  snap: PrivateQuoteSnapDto[],
): Position => {
  const privateQuote = privateQuotes.find(aPrivateQuote => aPrivateQuote.symbol === model.symbol);

  if (!privateQuote) {
    return model;
  }
  let result = enrichNonTradablePosition(model, privateQuote);
  result = addNonTradablePositionSnapIfFound(result, snap);

  return result;
};

const mapPositionDtoToModel = (
  dto: PositionDto,
  privateQuotes: PrivateQuoteDto[],
  snap: PrivateQuoteSnapDto[],
): Position => {
  let result: Position = {
    id: dto.OrderId.toString(),
    symbol: dto.Symbol,
    description: dto.Description,
    quantity: dto.OpenQuantity,
    purchasePrice: dto.OpenPrice,
    isTradable: true,
    totalCost: dto.CostBasis,
  };

  result = makeNonTradablePositionIfFound(result, privateQuotes, snap);

  return result;
};

export const mapPositionListDtoToModel = (
  dtos: PositionDto[],
  privateQuotes: PrivateQuoteDto[],
  snap: PrivateQuoteSnapDto[],
): Position[] => dtos.map(dto => mapPositionDtoToModel(dto, privateQuotes, snap));
